<template>
   <div class="faqVideo">
       <!-- <div v-show="!showVideo" class="image" v-if="widget.image && widget.image !== ''">
           <img :src="`${directoryUrl}/img/${widget.image}`" @click="imageAction"/>
       </div> -->
       <div v-if="showVideo" class="responsiveContent">
           <div v-html="vimeoData.html"/>
        </div>
   </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'FaqVideo',
    props: {
        vimeoUrl: {
            type: String,
            required: true,
        },
    },
    computed: {
        directoryUrl () {
            return this.$store.state.clientConfig.directoryUrl;
        },
    },
    data () {
        return {
            vimeoData: null,
            showVideo: false,
        };
    },
    created () {
        this.initialise();
    },
    methods: {
        initialise () {
            let authSet = '';
            if (axios.defaults.headers.common.Authorization) {
                authSet = axios.defaults.headers.common.Authorization;
                axios.defaults.headers.common = {};
            }
            if (axios.defaults.headers.get.ImpersonateId) {
                axios.defaults.headers.get = {};
            }
            axios({
                method: 'get', // you can set what request you want to be
                url: `https://vimeo.com/api/oembed.json?url=${this.vimeoUrl}&width=500`,
                headers: {
                },
            })
                .then((response) => {
                    // handle success
                    this.vimeoData = response.data;
                    this.showVideo = true;
                });
            if (authSet !== '') {
                axios.defaults.headers.common.Authorization = authSet;
            }
        },
        imageAction () {
            if (this.vimeoData) {
                this.showVideo = true;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.faqVideo{
    .image{
        img {
            width:100%;
        }
    }
    .responsiveContent{
        position: relative;
        overflow: hidden;
        padding-top: 56.25%;
        ::v-deep iframe{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;
        }
    }
}
</style>
